import { _, api, helpers, ts } from '_core';

type DataSourceApiResponse = {
  data: ts.types.dataSource.DataSource;
};

export const createDataSource = async (
  newData: ts.types.dataSource.DataSourceDraft,
  callback: (_data: ts.types.dataSource.DataSource) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp: DataSourceApiResponse = await api.data_sources.create(newData);
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error creating data source - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateDataSource = async (
  id: number,
  newData: ts.types.dataSource.DataSourceDraft,
  callback: (_data: ts.types.dataSource.DataSource) => void,
  errorCallback: (_error: string) => void,
  increment = false
) => {
  try {
    const resp: DataSourceApiResponse = increment
      ? await api.data_sources.increment(id, { ...newData })
      : await api.data_sources.update(id, { ...newData });

    callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating data source - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateDefinition = async (
  id: number,
  definition: ts.types.dataSource.DataSourceDraft,
  callback: (_data: ts.types.dataSource.DataSource) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp = await api.data_sources.update(id, definition, true);
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating the definition - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateUiMetadata = async (
  dataSource: ts.types.dataSource.DataSource,
  uiMetaData: ts.types.dataSource.UiMetaData,
  callback: (_data: ts.types.dataSource.DataSource) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    if (dataSource.shared) return;
    const updateData = {
      ui_metadata: uiMetaData,
      skip_signature_check: true,
    } as ts.types.dataSource.DataSourceDraft;
    const resp = await api.data_sources.update(dataSource.id, updateData);
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating the resource metadata - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const getDataSource = async (
  id: number,
  userId: number,
  callback: (_data: ts.types.dataSource.DataSource, _prevHtml?: string) => void,
  errorCallback: () => void
) => {
  try {
    const resp = await api.data_sources.get(id);
    const respExtra = await api.uiApi.getDataSourceData({
      data: {
        handle: resp.data.handle,
        ignore_cache: true,
      },
    });
    const ds = {
      ...resp.data,
      ui_metadata: _.isEmpty(resp.data.ui_metadata) ? {} : resp.data.ui_metadata,
    };

    callback(
      {
        ...ds,
        shared: !ds.is_published && ds.shared_with.includes(userId) && ds.created_by_id !== userId,
      },
      respExtra.preview_html
    );
  } catch (error) {
    errorCallback();
  }
};
